module.exports = __webpack_public_path__ + "static/katoken-a4a87e7e6ef9d7fe93c966cd1749803f.png";